<span class="profile mat-display-large" (click)="profileClick.emit()">
  @if (user()?.avatarUrl) {
    <img [src]="user()?.avatarUrl" width="64" height="64" alt="Profile Photo" />
  } @else {
    <mat-icon fontSet="fa" size="30" fontIcon="fa-circle-user" inline></mat-icon>
  }
</span>
<div class="mat-body-medium">{{ user()?.firstName }}&nbsp;{{ user()?.lastName }}</div>
<div class="mat-body-small">{{ user()?.customerName }}</div>
